import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const OnboardingWrapper = styled(Grid)`
    row-gap: 24px;
`;

export const OnboardingContent = styled.div<{ $isMobile: boolean }>`
    margin: ${({ $isMobile }): string => ($isMobile ? '20px' : '40px 48px')};
    display: flex;
    flex-direction: column;
    gap: 32px;
`;
